import React, { useState } from 'react'
import { Button, Modal, FormControl, InputGroup } from 'react-bootstrap'
import { FaCopy } from 'react-icons/fa'

interface DownloadModalProps {
    show: boolean
    onHide: () => void
    downloadInfo: {title:string, link: string}
}

const DownloadModal: React.FC<DownloadModalProps> = ({ show, onHide, downloadInfo }) => {
    const [copied, setCopied] = useState(false)

    const handleCopyLink = () => {
        navigator.clipboard.writeText(downloadInfo.link)
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
    }

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{downloadInfo.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <InputGroup className="mb-3">
                    <FormControl value={downloadInfo.link} readOnly />
                    <Button variant="outline-secondary" onClick={handleCopyLink}>
                        <FaCopy />
                        {copied ? ' Copied!' : ' Copy Link'}
                    </Button>
                </InputGroup>
                <Button 
                    href={downloadInfo.link} 
                    
                    className="w-100"
                    variant="primary"
                >
                    Download
                </Button>
            </Modal.Body>
        </Modal>
    )
}

export default DownloadModal
